import * as Icons from "@nova/component-icons"
import classNames from "classnames"
import { OrthoPalettes } from "@nova/constants"
import { paletteIcons } from "../../hotspots/constants"

export const OrthoPalette = ({
    selectedPalette,
    setSelectedPalette,
    setOpenDropdownId,
}: {
    selectedPalette: OrthoPalettes
    setSelectedPalette: (palette: OrthoPalettes) => void
    setOpenDropdownId: (id: string | undefined) => void
}) => {
    return (
        <div className="rounded-xl flex gap-2 p-2 bg-gray-700 shadow-card relative items-center">
            {paletteIcons.map(([palette, icons], i) => (
                <div
                    key={i}
                    className={classNames("relative rounded-[0.4375rem] border", {
                        "border-gray-0": selectedPalette === palette,
                        "border-transparent": selectedPalette !== palette,
                    })}
                    onClick={() => {
                        setSelectedPalette(palette)
                        setOpenDropdownId(undefined)
                    }}
                >
                    <Icons.Icon
                        Icon={(palette === selectedPalette && icons.selected) || icons.default}
                        className="hover:brightness-125 cursor-pointer text-gray-400"
                    />
                    {selectedPalette === palette && (
                        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                            <Icons.ExtraSmallIcon
                                Icon={Icons.CheckmarkShadow}
                                className="text-gray-0 pointer-events-none"
                            />
                        </div>
                    )}
                </div>
            ))}
        </div>
    )
}
